import { forwardRef, useState, useImperativeHandle } from 'react';
import { ICellEditorParams, ICellEditor } from 'ag-grid-community';
import { VerticalSuperGridColDef } from '@aleph/supergrid';

export default forwardRef<ICellEditor, ICellEditorParams>((props, ref) => {
	const [value, setValue] = useState((props.colDef as VerticalSuperGridColDef)?.entityData?.namingExpression ?? props.data?.namingExpression ?? props.value);

	/* Component Cell Editor Lifecycle methods */
	useImperativeHandle(ref, () => ({
		getValue() {
			return value;
		},
		isCancelAfterEnd() {
			return value === (props.colDef as VerticalSuperGridColDef)?.entityData?.namingExpression
            || value === props.value
            || value === props.data?.namingExpression;
		},
	}));

	return (
		<input
			autoFocus
			className='w-full ag-input-field-input ag-text-field-input pl-[var(--ag-grid-size)]'
			type="text"
			value={value || ''}
			onChange={({ target: { value: newValue } }) => setValue(newValue)}
		/>
	);
});
